const cards = {
    // Fantasy Quiz Cards
    'fantasy1': {
        id: 'fantasy1',
        front: 'What is the most common language spoken by elves in fantasy literature?',
        back: 'Elvish (or Elven), often associated with languages like Sindarin or Quenya in J.R.R. Tolkien\'s works.'
    },
    'fantasy2': {
        id: 'fantasy2',
        front: 'In which fantasy series do characters travel to a world through a wardrobe?',
        back: '"The Chronicles of Narnia" by C.S. Lewis.'
    },
    'fantasy3': {
        id: 'fantasy3',
        front: 'What mythical creature is known for hoarding gold and breathing fire?',
        back: 'A Dragon.'
    },
    'fantasy4': {
        id: 'fantasy4',
        front: 'Which fantasy series features the phrase "Winter is coming"?',
        back: '"A Song of Ice and Fire" series by George R.R. Martin, popularly known as "Game of Thrones."'
    },
    'fantasy5': {
        id: 'fantasy5',
        front: 'Who is the author of the fantasy series "The Wheel of Time"?',
        back: 'Robert Jordan.'
    },
    'fantasy6': {
        id: 'fantasy6',
        front: 'What is the name of the sword carried by Aragorn in "The Lord of the Rings"?',
        back: 'Andúril.'
    },
    'fantasy7': {
        id: 'fantasy7',
        front: 'Which fantasy creature is often depicted as having the body of a lion, wings of an eagle, and a human face?',
        back: 'A Sphinx.'
    },
    'fantasy8': {
        id: 'fantasy8',
        front: 'In "Harry Potter," what magical object allows one to see the deepest desires of their heart?',
        back: 'The Mirror of Erised.'
    },
    'fantasy9': {
        id: 'fantasy9',
        front: 'In the "Harry Potter" series, what creature guards the vaults at Gringotts Wizarding Bank?',
        back: 'A Dragon.'
    },
    'fantasy10': {
        id: 'fantasy10',
        front: 'Which author created the world of "Middle-earth"?',
        back: 'J.R.R. Tolkien.'
    },
    'fantasy11': {
        id: 'fantasy11',
        front: 'In which series would you find a character named Daenerys Targaryen?',
        back: '"A Song of Ice and Fire" by George R.R. Martin.'
    },
    'fantasy12': {
        id: 'fantasy12',
        front: 'What is the name of the land where Aslan reigns in "The Chronicles of Narnia"?',
        back: 'Narnia.'
    },
    'fantasy13': {
        id: 'fantasy13',
        front: 'Which magical artifact is sought by Frodo Baggins in "The Lord of the Rings"?',
        back: 'The One Ring.'
    },
    'fantasy14': {
        id: 'fantasy14',
        front: 'In fantasy lore, what type of creature is Smaug?',
        back: 'A Dragon.'
    },
    'fantasy15': {
        id: 'fantasy15',
        front: 'Which fantasy series is set in the world of Westeros?',
        back: '"A Song of Ice and Fire" by George R.R. Martin.'
    },
    'fantasy16': {
        id: 'fantasy16',
        front: 'Who is the main antagonist in J.R.R. Tolkien’s "The Lord of the Rings"?',
        back: 'Sauron.'
    },

    // Nature Quiz Cards
    'nature1': {
        id: 'nature1',
        front: 'What is the largest rainforest in the world?',
        back: 'The Amazon Rainforest.'
    },
    'nature2': {
        id: 'nature2',
        front: 'Which is the tallest mountain on Earth?',
        back: 'Mount Everest.'
    },
    'nature3': {
        id: 'nature3',
        front: 'Which ocean is the largest in the world?',
        back: 'The Pacific Ocean.'
    },
    'nature4': {
        id: 'nature4',
        front: 'What natural phenomenon is known as the "Aurora Borealis"?',
        back: 'The Northern Lights, a natural light display predominantly seen in high-latitude regions.'
    },
    'nature5': {
        id: 'nature5',
        front: 'Which is the fastest land animal?',
        back: 'The Cheetah.'
    },
    'nature6': {
        id: 'nature6',
        front: 'What is the largest desert in the world?',
        back: 'The Sahara Desert.'
    },
    'nature7': {
        id: 'nature7',
        front: 'Which is the longest river in the world?',
        back: 'The Nile River.'
    },
    'nature8': {
        id: 'nature8',
        front: 'What type of ecosystem covers the largest portion of the Earth’s surface?',
        back: 'The Marine Ecosystem (Oceans).'
    },
    'nature9': {
        id: 'nature9',
        front: 'Which tree is known for its longevity and can live for thousands of years?',
        back: 'The Bristlecone Pine.'
    },
    'nature10': {
        id: 'nature10',
        front: 'Which animal is known for its unique black and white stripes?',
        back: 'The Zebra.'
    },
    'nature11': {
        id: 'nature11',
        front: 'What is the most common gas in the Earth’s atmosphere?',
        back: 'Nitrogen.'
    },
    'nature12': {
        id: 'nature12',
        front: 'Which part of the plant is primarily responsible for photosynthesis?',
        back: 'The Leaf.'
    },
    'nature13': {
        id: 'nature13',
        front: 'What is the largest species of bear?',
        back: 'The Polar Bear.'
    },
    'nature14': {
        id: 'nature14',
        front: 'Which bird is known for its ability to mimic sounds, including human speech?',
        back: 'The Parrot.'
    },
    'nature15': {
        id: 'nature15',
        front: 'What is the process by which plants make their own food using sunlight?',
        back: 'Photosynthesis.'
    },
    'nature16': {
        id: 'nature16',
        front: 'Which layer of the Earth is the hottest?',
        back: 'The Core.'
    },

    // Society Quiz Cards
    'society1': {
        id: 'society1',
        front: 'What is the term for a society where the eldest male is the head of the family?',
        back: 'Patriarchy.'
    },
    'society2': {
        id: 'society2',
        front: 'Which system of government is defined by the rule of the people?',
        back: 'Democracy.'
    },
    'society3': {
        id: 'society3',
        front: 'What term describes the practice of moving from one place to another, typically for work or better living conditions?',
        back: 'Migration.'
    },
    'society4': {
        id: 'society4',
        front: 'What is the study of human societies and cultures called?',
        back: 'Anthropology.'
    },
    'society5': {
        id: 'society5',
        front: 'What is the term for a social system in which property is owned by the community as a whole?',
        back: 'Communism.'
    },
    'society6': {
        id: 'society6',
        front: 'Which term describes a society governed by the wealthy?',
        back: 'Plutocracy.'
    },
    'society7': {
        id: 'society7',
        front: 'What is the term for discrimination based on race?',
        back: 'Racism.'
    },
    'society8': {
        id: 'society8',
        front: 'What term is used to describe the spread of cultural beliefs and social activities from one group to another?',
        back: 'Cultural Diffusion.'
    },
    'society9': {
        id: 'society9',
        front: 'What is the term for unequal treatment of people based on gender?',
        back: 'Sexism.'
    },
    'society10': {
        id: 'society10',
        front: 'What is the study of population structure and dynamics called?',
        back: 'Demography.'
    },
    'society11': {
        id: 'society11',
        front: 'Which economic system is characterized by private ownership and free markets?',
        back: 'Capitalism.'
    },
    'society12': {
        id: 'society12',
        front: 'What is the term for the movement advocating for the equal rights of women?',
        back: 'Feminism.'
    },
    'society13': {
        id: 'society13',
        front: 'What is a social structure where individuals are divided into hierarchical groups based on occupation and wealth?',
        back: 'Social Stratification.'
    },
    'society14': {
        id: 'society14',
        front: 'What is the term for a group of people living together in the same place or having a particular characteristic in common?',
        back: 'Community.'
    },
    'society15': {
        id: 'society15',
        front: 'Which term describes a society governed by a king or queen?',
        back: 'Monarchy.'
    },
    'society16': {
        id: 'society16',
        front: 'What term describes the process by which people learn and adopt the norms, values, and behaviors of their society?',
        back: 'Socialization.'
    }
};

export default cards;
